import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickSmallWhy({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#F4F5FB" cx={8} cy={8} r={8} />
        <path
          d="M8 9.75A1.13 1.13 0 118 12a1.13 1.13 0 010-2.25zM8.05 4a2.93 2.93 0 011.67.62c.23.19.42.42.57.69a1.76 1.76 0 01.14 1.4c-.05.17-.12.31-.19.42a2.88 2.88 0 01-.94.75c-.15.08-.27.2-.37.35-.1.16-.15.5-.15.6 0 .06-.02.11-.07.17a.17.17 0 01-.15.08h-1.3c-.05 0-.1-.03-.14-.1a.42.42 0 01-.06-.2v-.47c0-.3.12-.58.36-.85.23-.26.5-.46.77-.59.22-.1.37-.2.46-.3a.6.6 0 00.13-.41c0-.15-.08-.29-.25-.4a1 1 0 00-.58-.18c-.24 0-.43.06-.59.16-.12.1-.32.3-.58.62a.2.2 0 01-.17.1.26.26 0 01-.13-.05l-.9-.68a.2.2 0 01-.08-.14c0-.05 0-.1.03-.15A2.77 2.77 0 018.05 4z"
          fill="#56A"
        />
      </g>
    </svg>
  );
}

SvgTickSmallWhy.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickSmallWhy.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickSmallWhy svgRef={ref} {...props} />);
export default ForwardRef;
